module.exports = __webpack_public_path__ + "img/onlineshop.b9094e29.jpg";